import {type MouseEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {Grid, Typography} from '@mui/material';
import {isEmpty} from 'utils';
import type {BookmarkFolder} from 'types';
import {AdminBookmarkCard} from '../cards';
import AdminBookmarksCardGridItem from '../AdminBookmarksCardGridItem';
import AdminBookmarksFolderHeader from './AdminBookmarksFolderHeader';

type AdminBookmarksFolderViewProps = {
  folder: BookmarkFolder | null;
  handleBack: MouseEventHandler;
}

const AdminBookmarksFolderView = ({ folder: { name, bookmarks }, handleBack } : AdminBookmarksFolderViewProps) => {
  return <>
    <AdminBookmarksFolderHeader handleBack={handleBack} name={name} />
    {isEmpty(bookmarks)
    ? <Grid item xxs={12}>
        <Typography sx={{marginTop: '20vh'}} textAlign='center' variant='h3' color='white'>
          <FormattedMessage id="admin.bookmarks.folder.empty" />
        </Typography>
      </Grid>
    : bookmarks.map(folderOrBookmark => (
        <AdminBookmarksCardGridItem key={folderOrBookmark.key}>
          <AdminBookmarkCard
            bookmark={folderOrBookmark}
          />
        </AdminBookmarksCardGridItem>
      ))
    }
  </>
}

export default AdminBookmarksFolderView;